import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { ViewCatalogProductsContext } from 'src/sections/catalog_products/ViewCatalogProductsContext';
import { useContextSelector } from 'use-context-selector';

const DescriptionCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);

  const handleViewProductDetails = useContextSelector(
    ViewCatalogProductsContext,
    (state) => state.handleViewProductDetails
  );
  const isFetchingProductDetails = useContextSelector(
    ViewCatalogProductsContext,
    (state) => state.isFetchingProductDetails
  );
  const loadingProductDetails = useContextSelector(
    ViewCatalogProductsContext,
    (state) => state.loadingProductDetails
  );
  const isDisabled = loadingProductDetails || isFetchingProductDetails;

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={value}>
      <button
        disabled={isDisabled}
        className="text-[#0000FF] hover:underline focus:outline-2 focus:outline-black rounded text-left truncate w-[100%]"
        onClick={(e) => handleViewProductDetails(e, props.dataItem)}
      >
        {value}
      </button>
    </GridCellBase>
  );
};

export default DescriptionCell;
